import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from 'react-bootstrap';
import ModalTransactionDetails from '../skusTransactions/ModalTransactionDetails';
import EditCreateSkuForm from './EditCreateSkuForm';
import CustomPagination from "../elements/CustomPagination";

const SkuList = (props) => {
    const { t } = useTranslation("dealer_sku_pannel");
    const role_access = props?.role_access;
    
    const [showModal, setShowModal] = useState(false);
    const [showModalSkuForm, setShowModalSkuForm] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [skuRecords, setSkuRecords] = useState([]);
    const [skuTypes, setSkuTypes] = useState([]);
    const [skuListingTypes, setSkuListingTypes] = useState([]);
    const [modelAction, setModelAction] = useState('');
    const [modelData, setModelData] = useState(null)

    useEffect(() => {
        // setTransactions(props.transactionList);
        setSkuRecords(props.sku_list);
        setSkuTypes(props.sku_types);
        setSkuListingTypes(props.skuListingTypes);
        setIsLoading(props.isLoading);
    }, [props]);

    const handleViewClick = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleViewClickSkuForm = (actionType='', updateObj) => {
        setShowModalSkuForm(true);
        setModelAction(actionType);
        setModelData(updateObj);
    };

    const handleCloseModalSkuForm = (isSaved=false) => {
        setShowModalSkuForm(false);

        if (isSaved) {
            props?.fetchSkuList();
        }
    };

    return (
        <div className="container-fluid new-theme">
            <div className='dealer-card m-lg m-md-l m-md-r transactions-table'>
                <div className="d-flex m-md-b align-center">
                    <h2 className="m-0-b">SKUs List</h2>
                    <button className="btn btn-success t-uppercase ml-auto" onClick={() => handleViewClickSkuForm('create')}>
                        Create SKU
                    </button>
                </div>
                <div className={isLoading ? "container-fluid loading result-wrap" : "container-fluid result-wrap"}>
                    <div className='table-responsive'>
                        <table className="table-style-2">
                            <thead>
                                <tr>
                                    <th style={{ textAlign: "center" }}>{t("Listing.sku_table.ID")}</th>
                                    <th style={{ textAlign: "center" }}>{t("Listing.sku_table.SKU_NAME")}</th>
                                    <th style={{ textAlign: "center" }}>{t("Listing.sku_table.QUOTA")}</th>
                                    <th style={{ textAlign: "center" }}>{t("Listing.sku_table.TOTAL_DAILY_LEADS")}</th>
                                    <th style={{ textAlign: "center" }}>{t("Listing.sku_table.PERIOD")}</th>
                                    <th style={{ textAlign: "center" }}>{t("Listing.sku_table.SKU_TYPE")}</th>
                                    <th style={{ textAlign: "center" }}>{t("Listing.sku_table.LISTING_TYPE")}</th>
                                    <th style={{ textAlign: "center" }}>{t("Listing.sku_table.PRICE")}</th>
                                    <th style={{ textAlign: "center" }}>{t("Listing.sku_table.DISCOUNT")}</th>
                                    <th style={{ textAlign: "center" }}>{t("Listing.sku_table.STATUS")}</th>
                                    <th style={{ textAlign: "center" }}>{t("Listing.sku_table.ACTION")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {skuRecords?.map((record, index) => (
                                    <tr key={record?.id || index}>
                                        <td style={{ textAlign: "center" }}>{record.id}</td>
                                        <td style={{ textAlign: "center" }}>{record.name}</td>
                                        <td style={{ textAlign: "center" }}>{record.quota}</td>
                                        <td style={{ textAlign: "center" }}>{`${record.total_leads}/${record.daily_leads}`}</td>
                                        <td style={{ textAlign: "center" }}>{record.active_period_days}</td>
                                        <td style={{ textAlign: "center" }}>{skuTypes && skuTypes?.length > 0 ? skuTypes.find((t) => +t.value === +record.sku_type)?.label || record.sku_type : record.sku_type}</td>
                                        <td style={{ textAlign: "center" }}>{skuListingTypes && skuListingTypes?.length > 0 ? skuListingTypes.find((lType) => +lType.value === +record.listing_type)?.label || record.listing_type : record.listing_type}</td>
                                        <td style={{ textAlign: "center" }}>{record.price}</td>
                                        <td style={{ textAlign: "center" }}>{record.discount_to_be_shown}</td>
                                        {/* <td style={{ textAlign: "center" }}>{SKU_PACKAGE_STATUS?.find(s => s.value === record.status).label || record.status}</td> */}
                                        {/* <td style={{ textAlign: "center" }}>
                                            {(() => {
                                                const status = props?.statusOptions?.find(s => s.value === record.is_expired);
                                                const label = status?.label || record.is_expired;

                                                if (label.toLowerCase() === 'active') {
                                                    return <span style={{ color: 'green', fontWeight: 'bold' }}>{label}</span>;
                                                } else if (label.toLowerCase() === 'expired') {
                                                    return <span style={{ color: 'red', fontWeight: 'bold' }}>{label}</span>;
                                                } else {
                                                    return label;
                                                }
                                            })()}
                                        </td> */}
                                        <td style={{ textAlign: "center" }}>
                                            {(() => {
                                                const status = props?.statusOptions?.find(s => s.value === record.is_enable);
                                                const label = status?.label || record.is_enable;

                                                if (label.toLowerCase() === 'enable') {
                                                    return <span style={{ color: 'green', fontWeight: 'bold' }}>{label}</span>;
                                                } else if (label.toLowerCase() === 'disable') {
                                                    return <span style={{ color: 'red', fontWeight: 'bold' }}>{label}</span>;
                                                } else {
                                                    return label;
                                                }
                                            })()}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                            <button className="btn-solid w-auto btn-sm bg-orange t-uppercase" onClick={() => handleViewClickSkuForm('update', record)}>
                                                Edit
                                            </button>
                                        </td>
                                    </tr>
                                ))
                                }
                            </tbody>
                        </table>
                        {/* When no Records available */}
                        {!isLoading && skuRecords.length === 0 ? (
                            <>
                                <div align="center" className="center" style={{ marginTop: "20px" }}>
                                    <h6 className="text-center text-danger text-bold">{t("Listing.NO_RECORD_FOUND")}</h6>
                                </div>
                            </>
                        ) : null}
                        {/* End No Records found */}
                    </div>
                    {skuRecords.length > 0 && <CustomPagination
                        currentPage={props.currentPage}
                        totalPages={props.totalPages}
                        onPageChange={props.onPageChange}
                    />}
                </div>
            </div>

            {/* Modal */}
            <Modal show={showModal} onHide={handleCloseModal} className='modal-subscription modal-transaction' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Transaction Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalTransactionDetails />
                </Modal.Body>
            </Modal>

            {/* Modal Create Sku */}
            <Modal show={showModalSkuForm} onHide={handleCloseModalSkuForm} className='modal-subscription modal-create-sku new-theme' centered>
                <Modal.Header closeButton>
                    <Modal.Title>{modelAction === 'create' ? `Create SKU` : 'Update SKU'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EditCreateSkuForm
                        isLoading={isLoading}
                        skuTypes={skuTypes}
                        listingTypes={skuListingTypes}
                        modelAction={modelAction}
                        handleClose={handleCloseModalSkuForm}
                        modelData={modelData}
                        roleAccess={role_access}
                        fetchSkuList={props?.fetchSkuList}
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default SkuList;